import { trackPageRequest } from './appComponents/shared/PageLoadingService';
import { authenticatedPut } from './appComponents/shared/AuthenticatedAPI';
import Amplify, { Auth, Storage, API } from 'aws-amplify'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'

import './../styles/Home.css'; // Tell webpack that Button.js uses these styles
import './../index.css';
import React, {Component, Fragment, useRef, useLayoutEffect} from 'react';


import blenderCommissionPublicKey from '../blenderData/blenderCommissionPublicKey.js';
import blenderTransfersToPublicKey from '../blenderData/blenderTransfersToPublicKey.js';
import { Mosaic, OrbitProgress, ThreeDot } from "react-loading-indicators";

import {isMobile} from 'react-device-detect';

import awsconfig from '../aws-exports.js';
import { navigationHandler, routeProps } from '../utilities/navigator.js';
import LoadingIcons from 'react-loading-icons'
import blenderPrivateKey  from '../blenderData/generalPrivateKey.js';
import { tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms,  LENDERBLOCKADMINWHITELIST} from '../blenderData/securityConfigurations.js';
import { Link, useParams } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css'
import { 
  Button, 
  ButtonContent,
  ButtonGroup,
  Modal, 
  Header, 
  Image, 
  Container,
  ListList,
  ListItem,
  ListIcon,
  Icon,
  Input,
  ListHeader,
  ListDescription,
  ListContent,
  List,
  FormField, 
  Form, 
  Radio,
} from 'semantic-ui-react';
import { ethers } from 'ethers';
import axios from 'axios';


import CampaignContract_latest from '../ethereum/build/latest/Campaign.json';
import CampaignFactoryContract_latest from '../ethereum/build/latest/CampaignFactory.json';
import HomeMobileRender from './home/HomeMobileRender.jsx';
import HomeDesktopRender from './home/HomeDesktopRender.jsx';

const Web3 = require('web3');
const CryptoJS = require("crypto-js");

var AWS = require('aws-sdk');

var mimemessage = require('mimemessage');

Amplify.configure(awsconfig);
Auth.configure(awsconfig);

var primaryLanguage;
var mode_light_dark;

var checkValidAuthTokenInterval;

var cognitoID;
var currentUser;
var currentUserCap;


var primaryDisplayCurrency;
var secondaryDisplayCurrency;
var publicKey;
var corporateBackedUsernamesArray;
var emailAddress;
let that;
let isSubscribedCurrentBool = false;

let applicantUsername;








let lastNonce;
var USDEtherConversionRate;
var tokenID;
var cognitoID;
var publicKey;
var privateKey;
var currentUser;
let cardEntryFormTimer;
let exitFundWalletTimer;
let firstName ;
let lastName;
let fullAddress;
let postalCode; 
let fullName;
let street;
let city;
let state;
let country;
let resultMessageTimer;
let cardFundComponent;
let countryCodes;
let countryNames;
let countryCodeSwappedJSONList;
let optionCountryCodeSwappedJSON;
let countryCodeSwappedJSON;
let proposeGasPrice;




const debounce = require('lodash/debounce');

var PIXELAJUST = 725;


var web3;
var highRateWeb3;

var privateKey;
var pageOrigin;

var allValues
var chartData
var rand1; 
var rand2;
var rand3;
var rand4;
var allDaysElapsed;
var joinDateSecs;
var openContracts;
var totalBorrContracts 
var blenderScore 
var notificationCount
var lenders
var notifs
var chartDayRange;
var compoundedDebtSum;
var currentLentSum;

let stakedContractsList;
let primaryDisplayPrice;
let secondaryDisplayPrice;
let forexJSON;


var walletBalanceWei;

var cognitoID;


var squareCustomerID;

var corporateBackedUsernamesArray;
var openBorrowingContractsDetails_creditLine = []
var openLendingContractsDetails_creditLine = []
var openStakingContractsDetails_creditLine = []

var openBorrowingContractsDetails_loanAgreement = []
var openLendingContractsDetails_loanAgreement = []
var openStakingContractsDetails_loanAgreement = []

var addedContracts_creditLine = []
var addedContracts_loanAgreement = []
let mediaMapArrayUserMap = {}

var noAccountsWarning_creditLine;
var noAccountsWarning_loanAgreement;

var exitTutorialTimer_3, exitTutorialTimer_2, exitTutorialTimer_1;
var buttonColorFlashIntervalDefault;
var flashCounter = 0;

let mediaArray;
let mediaArrayMap;

var fundWalletPromptDidBool = false;
let verifyOverlayShownBool = false;






















let monthLengtheningEnum = {
    JAN: 'January',
    FEB: 'February',
    MAR: 'March',
    APR: 'April',
    MAY: 'May',
    JUN: 'June',
    JUL: 'July',
    AUG: 'August',
    SEP: 'September',
    OCT: 'October',
    NOV: 'November',
    DEC: 'December',
}

class HomeComponent extends Component {

    constructor() {
      super()


    
      this.state = {
          usernameText: '',
          passwordText: '',
          touched: false,
          navigationDestinationObject: {
            navigationRoute: '',
          },
          button_recentApp_opacity: 1,
          button_pendingApp_opacity: 1,
          pendingApplicationsList: [],
          requestedAwaitingDocumentList: [],
          messageLineArray: [],
          submittedDocumentIDList: [],
          ableToFinalizeAndApproveBool: false,
          clientCorrespondenceMsgTextString: '',
          applicantUserFirstName: null,
          showLoaderOverlay: false,
          overheadApplicationApprovalString: '',
          applicationApprovedStatus: false,
          applicantUserFirstName: '',
          applicantEmailAddress: '',
          applicantUsername: '',
          messageInflight: false,
          didMessageSend: false,
          openBorrowingContractsDetails_creditLine: [],
          openLendingContractsDetails_creditLine: [],
          openStakingContractsDetails_creditLine: [],
          compoundedDebtSum: 0,
          currentLentSum: 0,
          moneyTransactionPreset: 'deposit',
          moneyTransactionLiveValue: null,
          outputOverlay: false,
          timeoutCheckSessionOverlay: false,
          successfulDepositOverlay: false,
          successfulTransferOverlay: false,
          successfulWithdrawalOverlay: false,
          chargeResult: null,
          popupBlockerOverlay: false,
          destinationAddress: null,
          destinationUsername: null,
          transferCommissionPercentDecimal: 0.05,
          isSubscribedCurrentBool: false,
          showPasswordOverlay: false,
          transactionConfirmationMessage: null,
          recipientUser: null,
          passwordIsHiddenBool: true,
          generalNoticeOverlay: false,
          pendingTransactionLoaderOverlay: false,
          last4AccountNumbers_bankAccount: null,
          chargeIDToken_bankAccount: null,
          chargeCurrency: 'usd',
          initialLoadingOverlay: false,
          externalAccountType: 'Bank Account',
          currentUserProfilePicture: null,
          selectedLanguage: null,
          mode_light_dark: null,
          socialOverlay: false,
          socialOverlayData_username: null,
          socialOverlayData_fullName: null,
          socialOverlayData_imageURI: null,
          socialOverlayData_bioString: null,
          socialOverlayData_contractAddress: null,
          mediaMapArray: null,
          currentUser: null,
          errorTags: null,
          moneyTransferOverlay: false,
          walletBalanceUSD: 0,
          walletBalanceWei: 0,
          maxWalletWithdrawalWei: 0,
          verifyIDOverlay: false,
          activeSearchBorrowerAccountBool: false,
          activeSearchTransferBool: false,
          allUserUsernamesDisplayNames: [],
          activeSearchTransferBool: false
                   };
      that = this

      
      

      web3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosischain.com/"));
      highRateWeb3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosis.gateway.fm"));


      trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
        currentUser = res.username
        cognitoID = res.signInUserSession.idToken.jwtToken

        currentUserCap = currentUser.toUpperCase()

      })
  }

  setNativeNotification(generalNoticeText){
    that.setState({
      generalNoticeOverlay: true,
      generalNoticeText
    })
  }

  componentWillUnmount(){
  }

  toggleTouched = () => {
      that.setState( prevState => ({
      touched: !prevState.touched
      }));
  }
  
  handleMouseUp = () => {
      // Handle smooth animation when clicking without holding
      setTimeout( () => {
      that.setState({ touched: false });
      }, 150);
  }

  formContents(){


    let userStats;

  
        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'users',  
            primaryKey: currentUser, 
            requestOperation: 'get',
          }
        }).then(response => {


          userStats = response.Item
          privateKey = response.Item.privateKey
          publicKey = response.Item.publicKey

          if((
            response.Item.hasOwnProperty('firstName') &&
            response.Item.hasOwnProperty('lastName') &&
            response.Item.hasOwnProperty('streetAddress') &&
            response.Item.hasOwnProperty('phone') &&
            response.Item.hasOwnProperty('dob') &&
            response.Item.hasOwnProperty('last4SSN')
          )){
            that.setState({})
          } else {
            that.setState({})
          }

          trackPageRequest(web3.eth.getBalance(publicKey))
            .then((res) => { 

              if(response.Item.hasOwnProperty('openContracts')){
                stakedContractsList = response.Item.stakedContracts ?? [];
                openContracts = [...new Set([...(response.Item.openContracts ?? []), ...stakedContractsList])];
                joinDateSecs = response.Item.joinDateSecs
                allDaysElapsed = parseInt((Date.now()-joinDateSecs)/86400000)
               
                let currentDay = parseInt(Date.now()/86400000)
                let timeArray = []
                let lastValue = 0;
                let lastValueDelta = 0; 
                let highestValue, lowestValue
                let daysJoined
                allValues = []

                for(let t=currentDay; t>=currentDay - 365*3; t--){
                  timeArray.unshift(t)
                }
                
                let values = []
                let firstDayValueFound = false;
                let firstDayValue;
                let firstDayValueIndex;
                let firstDayValueDelta;
                let lastDayValueFound = false;
                let lastDayValue;
                let lastDayValueIndex;
                let previousDayValue1;
                let previousDayValueIndex;
                let allZeroValues = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
    
                for(let j=0; j<=timeArray.length-1; j++){
                  if(userStats.dayEquities.hasOwnProperty(timeArray[j])){
                    previousDayValue1 = userStats.dayEquities[timeArray[j]].value
                    previousDayValueIndex = j
                    if(firstDayValueFound == false){
                      firstDayValueFound = true
                      firstDayValue = userStats.dayEquities[timeArray[j]].value
                      firstDayValueDelta = userStats.dayEquities[timeArray[j]].valueDelta
                      firstDayValueIndex = j
                    }
                  }
                  if(j == timeArray.length-1){
                    if(previousDayValue1){
                      lastDayValueFound = true
                      lastDayValue = previousDayValue1
                      lastDayValueIndex = previousDayValueIndex
                    } else {
                      values = allZeroValues
                    }
                  }
                }
    
                if(values.length == 0){
                  let previousDayValue2
                  for(let b=0; b<=timeArray.length-1; b++){
                    let nextValue
                    if(timeArray.length-1 - b <= that.state.chartDayRange){

                      if(b < firstDayValueIndex){
                        nextValue = (Number(firstDayValue) - Number(firstDayValueDelta)) 
                        if(isNaN(nextValue)){
                          nextValue = values[values.length-1]
                        }
                        values.push(nextValue)
                      } else if(b == firstDayValueIndex){
                        nextValue = Number(firstDayValue)
                        if(isNaN(nextValue)){
                          nextValue = values[values.length-1]
                        }
                        values.push(nextValue)
                        previousDayValue2 = firstDayValue
                      } else if(b >= lastDayValueIndex){
                        nextValue = Number(lastDayValue) 
                        if(isNaN(nextValue)){
                          nextValue = values[values.length-1]
                        }
                        values.push(nextValue)
                      } else if(b > firstDayValueIndex && b < lastDayValueIndex){
                        if(userStats.dayEquities.hasOwnProperty(timeArray[b])){
                          nextValue = Number(userStats.dayEquities[timeArray[b]].value) 
                          if(isNaN(nextValue)){
                            nextValue = values[values.length-1]
                          }
                          values.push(nextValue)
                          previousDayValue2 = userStats.dayEquities[timeArray[b]].value
                        } else {
                          nextValue = Number(previousDayValue2) 
                          if(isNaN(nextValue)){
                            nextValue = values[values.length-1]
                          }
                          values.push(nextValue)
                        }
                      }
                    }
                  }
                }


                let lastEquityValue = Math.round(parseFloat(parseInt(values[values.length-1])/(1000000000000000000))*100000)/100000
                lastEquityValue = lastEquityValue.toFixed(2)

                that.setState({ 
                  values,
                  lastEquityValue
                })


                addedContracts_creditLine = []
                addedContracts_loanAgreement = []

                compoundedDebtSum = 0;
                currentLentSum = 0;
                mediaMapArrayUserMap = {}

                if(openContracts.length != 0){
                  for (let c=0; c<=openContracts.length-1; c++){
                    let isCorporateBondBool, thatContractAddress, thatContract, notif, notifColor, manager, balance, managerDisplay, daysUntilSettlement, compoundedDebt_commissioned, contractColor, compoundedDebtColor, compoundedInterestReceivedColor, balanceColor, balanceFontWeight, blenderScoreColor, availableCredit, paymentStatus, paymentStatusColor

                    let balanceColor_1, balanceColor_2, balanceFontWeight_1, balanceFontWeight_2;

                    // that.setState({
                    //   addedContracts_creditLine,
                    //   openLendingContractsDetails_creditLine,
                    //   openStakingContractsDetails_creditLine,
                    //   openBorrowingContractsDetails_creditLine
                    // })
                    thatContractAddress = openContracts[c]
                    

                    let campaign = new web3.eth.Contract( 
                      CampaignContract_latest.abi,
                      thatContractAddress
                    );
                    
                    
                    let managerDisplayName = null;


                    authenticatedPut('api1169ba1e', '', { 
                      headers: { Authorization: `Bearer ${cognitoID}` },
                      body: { 
                        category: 'db',
                        tableName: 'contracts', 
                        primaryKey: openContracts[c], 
                        requestOperation: 'get',
                      }
                    }).then(response => {
                      if(response.hasOwnProperty('Item')){

                        let offeredLenderCommissionUSD_adjusted
                        let _exitReclaimableValueWei, _safeReclaimableValueWei
                        let exitReclaimableValue, safeReclaimableValue
                        
                        let minimumPayment = response.Item.minLoan
                        let lastPaymentDate = response.Item.lastPaymentDate;
                        let paymentReceiptsArray = response.Item.paymentReceipts;
                        let timeSinceLastPayment = Date.now() - lastPaymentDate;
                        let twoMonthsMillisecs = 5184000000; 
                        let oneMonthMillisecs = 2678000000;
                        let manager = response.Item.managerUsername
                        let displayName = response.Item.managerUsername
                        let targetValue = response.Item.targetValue
                        let lookupKey = response.Item.lookupKey
                        let creationDate = response.Item.creationDate
                        let approversList = response.Item.lenders
                        let compoundedDebt = response.Item.compoundedBalance
                        let settlementTimestamp, settlementDateFormatted, closureTimestamp, closureDateFormatted;
                        

                      
                        authenticatedPut('api1169ba1e', '', { 
                          headers: { Authorization: `Bearer ${cognitoID}` },
                          body: { 
                              category: 'db',
                              tableName: 'socialUserData', 
                              primaryKey: String(manager), 
                              requestOperation: 'get',
                          }
                        }).then((userData) => {
                          if(userData.hasOwnProperty('Item')){
                            if(userData.Item.hasOwnProperty('dynamicPublicUsername')){
                              displayName = userData.Item.dynamicPublicUsername
                            }
                          }                        
                      

                          authenticatedPut('api1169ba1e', '', { 
                            headers: { Authorization: `Bearer ${cognitoID}` },
                            body: { 
                              category: 'db',
                              tableName: 'users', 
                              primaryKey: manager, 
                              requestOperation: 'get',
                            }
                          }).then((userData) => {
                        
                            let firstName = userData.Item.firstName ?? ''
                            let lastName = userData.Item.lastName ?? ''

                            let fullName = firstName.substring(0,1).toUpperCase()+firstName.substring(1,firstName.length) + ' ' + lastName.substring(0,1).toUpperCase()+lastName.substring(1,lastName.length)
                            
                            
                            let isSubscribedCurrentBool = false;




                            
                            let headers = new Headers();

                            Promise.resolve().then(() => {
if (userData.Item.isSubscribedCurrentBool === true) {
                                      
                                      isSubscribedCurrentBool = true
                                      preBuildContractList()
                                    } else {
                                      
                                      isSubscribedCurrentBool = false
                                      preBuildContractList()
                                    }
});
                          
                        
                            




                            
                            function buildContractLists(
                              totalCollateralAssistanceOwed_staker, 
                              stakerCollateralValue,
                              stakerCommissionReceivedValue,
                              integerCommissionPCT,
                              integerStakerDerivedCommissionPCT,
                            ){
                              
                              let stakerCommissionPercentEntitle = Number(totalCollateralAssistanceOwed_staker) > 0
  ? (Number(stakerCollateralValue) / Number(totalCollateralAssistanceOwed_staker))
    * (Number(integerCommissionPCT) / 10000)
    * (Number(integerStakerDerivedCommissionPCT) / 100)
  : 0;
                              let stakerCollateralValueUSD = stakerCollateralValue/1000000000000000000;
                              let stakerCommissionReceivedValueUSD = stakerCommissionReceivedValue/1000000000000000000;


                            



                              var time = new Date().getTime(); // get your number
                              var date = new Date(time); // create Date object

                              let daysOfMonth = Number(date.toString().substr(10,2))
                              let daysOfMonthMillisec = daysOfMonth * 86400000

                              if(that.state.selectedLanguage == 'english'){
                                if(((timeSinceLastPayment > daysOfMonthMillisec && daysOfMonth >= 15)) && compoundedDebt > 0){
                                  paymentStatus = "OVERDUE"
                                  paymentStatusColor = 'rgba(20, 4, 45, 1)'
                                } else {
                                  paymentStatus = "GOOD"
                                  paymentStatusColor = 'rgba(0, 158, 129, 1)'
                                }
                              } else {
                                if(((timeSinceLastPayment > daysOfMonthMillisec && daysOfMonth >= 15)) && compoundedDebt > 0){
                                  paymentStatus = "ADEUDADO"
                                  paymentStatusColor = 'rgba(20, 4, 45, 1)'
                                } else {
                                  paymentStatus = "BUENO"
                                  paymentStatusColor = 'rgba(0, 158, 129, 1)'
                                }
                              }

                              
                              let backgroundColor;
                              let borderColor;

                              campaign.methods.closeContractBool().call()
                                .then((res) => {
                                  let closeContractBool = res
                                  if(closeContractBool){
                                    backgroundColor = 'rgba(41, 43, 43, 0.2)'
                                    borderColor = 'rgba(0, 0, 0, 0.5)'
                                  } else {
                                    backgroundColor = 'rgba(0, 158, 129, 0.05)'
                                    borderColor = 'rgba(0, 158, 129, 0.5)'
                                  }

                                  campaign.methods.getSummary1().call()
                                    .then((res) => {
                                      let web3BalancePost = String(res[0])
                                      let loanTarget = String(res[1])
                                      let minimumContribution = Number(res[2])
                                      let finalRequestsSum = String(res[4])
                                      let repaymentSum = String(res[5])
                                      let insuranceTotal = res[12]

                                      campaign.methods.getSummary2(publicKey).call()
                                      .then((res) => {
                                        let currentUserLoanTotal = Number(res[0])
                                        let userLiquidValue = Number(res[1])
                                        let userFinalizedRequestLoanSum = Number(res[2])
                                        let approverCheck = res[3]
                                        let reclaimableValue = Number(res[4])
                                        let compoundInterestReceived = Number(res[5])


                                        campaign.methods.getSummary3(publicKey).call()
                                          .then((res) => {


                                            let receivedPayments = Number(res[0])

                                            if(!isNaN(currentUserLoanTotal)){
                                              currentLentSum += currentUserLoanTotal
                                            }

                                        
                                            if(Number(finalRequestsSum) <= 1){
                                              offeredLenderCommissionUSD_adjusted = 0
                                            }
                                        
                                            if(Number(userLiquidValue) > Number(currentUserLoanTotal) - Number(minimumContribution) - 1){
                                              _exitReclaimableValueWei = Number(currentUserLoanTotal) - Number(userFinalizedRequestLoanSum) + 1000
                                              _safeReclaimableValueWei = Number(currentUserLoanTotal) - Number(minimumContribution) - 10000000
                                            } else {
                                              _exitReclaimableValueWei = Number(currentUserLoanTotal) - Number(userFinalizedRequestLoanSum) + 1000
                                              _safeReclaimableValueWei = (Number(userLiquidValue) * 0.9) - 10000000
                                            }

                                            if(_safeReclaimableValueWei < 0){
                                              _safeReclaimableValueWei = 0
                                            }

                                            if(_exitReclaimableValueWei < 0){
                                              _exitReclaimableValueWei = 0
                                            }
                                            exitReclaimableValue = (_exitReclaimableValueWei / 1000000000000000000).toFixed(2)
                                            safeReclaimableValue = (_safeReclaimableValueWei / 1000000000000000000).toFixed(2)


                                    
                                                  receivedPayments = ((receivedPayments / 1000000000000000000)).toFixed(2)

                                                  currentUserLoanTotal = ((currentUserLoanTotal / 1000000000000000000)).toFixed(2)
                                                  compoundInterestReceived = ((compoundInterestReceived / 1000000000000000000)).toFixed(2)
                                      
                                                  trackPageRequest(web3.eth.getBalance(thatContractAddress))
                                                    .then((bal) => { 
                                                      if(response.hasOwnProperty('Item')){
                                                        thatContract = response.Item
                                                      

                                                        minimumContribution = ((minimumContribution / 1000000000000000000)).toFixed(2)

                                                          
                                                        balance = Number(bal)
                                                        balance = parseFloat((balance - Number(thatContract.targetValue)/1.99)/(1000000000000000000 ))
                                                        balance = Math.round(parseFloat(balance, 10)*100000*0.95)/100000

                                                        balance = balance.toFixed(2)
                                                        
                                                        manager = thatContract.managerUsername
                                                        compoundedDebt = Math.round(parseFloat(Number(thatContract.compoundedBalance)/(1000000000000000000 )) * 100)/100

                                                        if(currentUser.toLowerCase() == manager.toLowerCase()){
                                                          compoundedDebtSum = Number(compoundedDebtSum) + Math.round(parseFloat(Number(thatContract.compoundedBalance)/(1000000000000000000 )) * 100000)/100000
                                                        }
                                                      
                                                        let USD_contractBalance = (((web3BalancePost - insuranceTotal) / 1000000000000000000))

                                                        if(USD_contractBalance <= loanTarget/1000000000000000000){
                                                          availableCredit = USD_contractBalance
                                                        } else {
                                                          availableCredit = loanTarget/1000000000000000000
                                                        }

                                                        availableCredit = Number(availableCredit).toFixed(2)
                                                        
                                                        that.setState({
                                                          compoundedDebtSum: Number(compoundedDebtSum).toFixed(2),
                                                          currentLentSum: ((currentLentSum / 1000000000000000000)).toFixed(2),
                                                        })
                                                        


                                                        // if(managerDisplayName && isSubscribedCurrentBool){
                                                        if(managerDisplayName && isSubscribedCurrentBool){
                                                          managerDisplay = managerDisplayName
                                                        } else {
                                                          managerDisplay = manager.toUpperCase()
                                                        }





                                                        authenticatedPut('api1169ba1e', '', { 
                                                          headers: { Authorization: `Bearer ${cognitoID}` },
                                                          body: { 
                                                            category: 'db',
                                                            tableName: 'users', 
                                                            primaryKey: manager, 
                                                            requestOperation: 'get',
                                                          }
                                                        }).then(response => {

                                                              let profilePicture_base64 = null;
                                                              let profilePicture_uri = null;
                                                              let bioString = null;

                                                              profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${manager.toLowerCase()}`;

                                                              Storage.get(
                                                                `${manager.toLowerCase()}/profilePicture.jpg`,
                                                                {
                                                                    bucket: "platform-user-media-uploads",
                                                                    level: "public"
                                                                }
                                                              ).then((res) => {

                                                                try {
                                                                  trackPageRequest(fetch(
                                                                    res
                                                                  )).then((image) => {
                          
                                                                    if(image.status == 200){
                                                                      profilePicture_uri = res;
                                                                    }
                                                                        buildMediaData();
                                                                        function buildMediaData(){

                                                                          authenticatedPut('api1169ba1e', '', { 
                                                                            headers: { Authorization: `Bearer ${cognitoID}` },
                                                                            body: { 
                                                                                category: 'db',
                                                                                tableName: 'socialUserData', 
                                                                                primaryKey: String(manager), 
                                                                                requestOperation: 'get',
                                                                            }
                                                                          }).then((userData) => {

                              
                              
                              
                                                                              if(userData.hasOwnProperty('Item')){
                                                                                if(userData.Item.hasOwnProperty('bioString')){
                                                                                  bioString = String(userData.Item.bioString)
                                                                                } else {
                                                                                  bioString = 'No Bio :('
                                                                                }
                              
                                                                                let mediaArray = []
                                                                                if(userData.Item.hasOwnProperty('mediaArray')){
                                                                                  mediaArray = userData.Item.mediaArray
                                                                                }
                                                                                
                                                                                let mediaMapArray = []
                              
                                                                                loopUserMediaArray(0)
                                                                                function loopUserMediaArray(m){
                              
                                                                                  if(m<=mediaArray.length-1){
                                                                                    let thisFileName = mediaArray[m]
                                                                                    let caption = '...'
                                                                                    let uploadTimestamp = 0;
                                                                                    let likesArray = [];
                                                                                    let commentsMapArray = [];
                                                                                    let commentsMap = {};

                                                                                    Storage.get(
                                                                                        thisFileName,
                                                                                        {
                                                                                            bucket: "platform-user-media-uploads",
                                                                                            level: "public"
                                                                                        }
                                                                                    ).then((res) => {
                                                                                        if(res){
                                                    
                                                                                            authenticatedPut('api1169ba1e', '', { 
                                                                                                headers: { Authorization: `Bearer ${cognitoID}` },
                                                                                                body: { 
                                                                                                    category: 'db',
                                                                                                    tableName: 'mediaUploads', 
                                                                                                    primaryKey: String(thisFileName), 
                                                                                                    requestOperation: 'get',
                                                                                                }
                                                                                            }).then((mediaData) => {
                                                                                                
                                                                                                if(mediaData.hasOwnProperty('Item')){
                                                                                                    if(mediaData.Item.hasOwnProperty('caption')){
                                                                                                      caption = String(mediaData.Item.caption)
                                                                                                    }
                                                                                                    if(mediaData.Item.hasOwnProperty('uploadTimestamp')){
                                                                                                      uploadTimestamp = String(mediaData.Item.uploadTimestamp)
                                                                                                    }
                                                                                                    if(mediaData.Item.hasOwnProperty('likesArray')){
                                                                                                      likesArray = mediaData.Item.likesArray
                                                                                                    }
                                                                                                    if(mediaData.Item.hasOwnProperty('commentsMap')){
                                                                                                      commentsMap = mediaData.Item.commentsMap
                                                                                                    }
                                                                                                    if(mediaData.Item.hasOwnProperty('commentsMapArray')){
                                                                                                      commentsMapArray = mediaData.Item.commentsMapArray
                                                                                                    }
                                                
                              
                              
                                                                                                    function loopCommentsArray(c){

                                                                                                      if(commentsMapArray.length-1 >= c && commentsMapArray.length > 0){
                                                                                                        let thisComment = commentsMapArray[c]
                                                                                                        let thisSender = thisComment.sender
                              
                                                                                                        let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${thisSender.toLowerCase()}`;
                                                                    
                                                                                                        Storage.get(
                                                                                                          `${thisSender.toLowerCase()}/profilePicture.jpg`,
                                                                                                          {
                                                                                                              bucket: "platform-user-media-uploads",
                                                                                                              level: "public"
                                                                                                          }
                                                                                                        ).then((res) => {
                                                                                                          trackPageRequest(fetch(
                                                                                                            res
                                                                                                          )).then((image) => {
                              
                                                                                                            if(image.status == 200){
                                                                                                              profilePicture_uri = res;
                                                                                                            }
                                                                                                            commentsMapArray[c]['profilePictureURI'] = profilePicture_uri
                                                                                                            commentsMapArray[c]['mediaFileName'] = thisFileName
                              
                                                                                                            let commentsReplyMapArray = []
                                                                                                            
                                                                                                            authenticatedPut('api1169ba1e', '', { 
                                                                                                              headers: { Authorization: `Bearer ${cognitoID}` },
                                                                                                              body: { 
                                                                                                                  category: 'db',
                                                                                                                  tableName: 'mediaUploadComments', 
                                                                                                                  primaryKey: commentsMapArray[c].messageID, 
                                                                                                                  requestOperation: 'get',
                                                                                                              }
                                                                                                            }).then((messageData) => {
                              
                                                                                                              if(messageData.hasOwnProperty('Item')){
                              
                                                                                                                commentsMapArray[c]['likesArray'] = messageData.Item.likesArray
                              
                                                                                                                if(messageData.Item.hasOwnProperty('commentsReplyMapArray')){
                                                                                                                  commentsReplyMapArray = messageData.Item.commentsReplyMapArray
                                                                                                                }
                                                                                                              
                                                                                                                function loopCommentsReplyArray(r){
                                                                                                                  if(commentsReplyMapArray.length-1 >= r && commentsReplyMapArray.length > 0){
                                                                                                                    let thisComment = commentsReplyMapArray[r]
                                                                                                                    let thisSender = thisComment.sender
                                            
                                                                                                                    let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${thisSender.toLowerCase()}`;
                                                                                
                                                                                                                    Storage.get(
                                                                                                                      `${thisSender.toLowerCase()}/profilePicture.jpg`,
                                                                                                                      {
                                                                                                                          bucket: "platform-user-media-uploads",
                                                                                                                          level: "public"
                                                                                                                      }
                                                                                                                    ).then((res) => {
                                                                                                                      trackPageRequest(fetch(
                                                                                                                        res
                                                                                                                      )).then((image) => {
                                                                                                                        if(image.status == 200){
                                                                                                                          profilePicture_uri = res;
                                                                                                                        }
                                                                                                                        commentsReplyMapArray[r]['profilePictureURI'] = profilePicture_uri
                                                                                                                        commentsReplyMapArray[r]['messageReplyID'] = commentsReplyMapArray[r].messageID
                                                                                                                        commentsReplyMapArray[r]['likesArray'] = commentsReplyMapArray[r].likesArray
                                                                                                                        
                              
                                                                                                                        loopCommentsReplyArray(r+1)
                                                                                                                      }).catch((err) => {

                                                                                                                      })
                                                                                                                    })
                                                                                                                  } else {
                                                                                                                    commentsMapArray[c]['commentsReplyMapArray'] = commentsReplyMapArray
                                                                                                                    loopCommentsArray(c+1)
                                                                                                                  }

                                                                                                                }
                              
                                                                                                                loopCommentsReplyArray(0)
                              
                              
                                                                                                              } else {
                                                                                                                loopCommentsArray(c+1)
                                                                                                              }
                                                                                                            })
                                                                                                          }).catch((err) => {

                                                                                                          })
                                                                                                        }).catch((err) => {

                                                                                                        })
                              
                                                                                                      } else {
                              
                                                                                                        mediaMapArray.unshift({
                                                                                                          mediaURI: res,
                                                                                                          mediaFileName: thisFileName,
                                                                                                          mediaItemCaption: caption,
                                                                                                          uploadTimestamp: uploadTimestamp,
                                                                                                          likesArray: likesArray,
                                                                                                          commentsMapArray: commentsMapArray,
                                                                                                          publisherUsername: String(manager)
                                                                                                        })
                                                        
                                                                                                        mediaMapArray.sort(function(a,b) {
                                                                                                            return (b.uploadTimestamp - a.uploadTimestamp)
                                                                                                        });
                              
                                                                                                        loopUserMediaArray(m+1)
                              
                                                                                                      }
                                                                                                    }
                                                                                                    loopCommentsArray(0);
                              
                                                                                                }
                                                                                            })
                                                                                            
                                                                                        }
                                                                                    }).catch((err)=>{
                                                                                      loopUserMediaArray(m+1)
                                                                                    })
                                                                                  } else {
                                                                                    mediaMapArrayUserMap[manager] = mediaMapArray
                                                                                    that.setState({
                                                                                      mediaMapArrayUserMap
                                                                                    })

                                                                                    buildContractMapArrays()
                                                                                  }
                                                                                }
                                                                              } else {
                                                                                bioString = 'No Bio :('
                                                                              }
                                                                            })
                                                                          }


                                                                          function buildContractMapArrays(){

                                                                            let alpha
                                                                            let _openContractsCt = parseInt(response.Item.openContracts.length, 10)
                                                                            let _totalRepaid_nonConvert = parseFloat(response.Item.totalPaid, 10)/1000000000000000000
                                                                            let _totalLending_nonConvert = parseFloat(response.Item.nowLending, 10)/1000000000000000000
                                                                            let _totalBorrowing_nonConvert = parseFloat(response.Item.nowBorrowing, 10)/1000000000000000000
                                                                            let _lendingRec_nonConvert = parseFloat(response.Item.totalLent, 10)/1000000000000000000
                                                                            let _borrowingRec_nonConvert = (parseFloat(response.Item.totalWithdrawn, 10)+1)/1000000000000000000
                                                                            let _joinDateSecs = response.Item.joinDateSecs
                                                                            let monthsJoined = ((Date.now() - _joinDateSecs)/(86400000*30))


                                                                            if(_borrowingRec_nonConvert == 0){
                                                                              blenderScore = 300
                                                                            } else {
                                                                              blenderScore = Math.ceil( 500 * (_totalRepaid_nonConvert/_borrowingRec_nonConvert) + 300 ) 
                                                                            }   
                                                                            
                                                                            if(corporateBackedUsernamesArray.includes(manager)){
                                                                              isCorporateBondBool = true
                                                                              managerDisplay = 'LB CORP.'
                                                                              blenderScore = ''
                                                                            } else {
                                                                              isCorporateBondBool = false
                                                                            }
                                                                            
                                                                            notificationCount = thatContract.notifications[currentUser];
                                                                            notifs = parseInt(notificationCount, 10)
                                                                            

                                                                            
                                                                          
                                                                          
                                                                            compoundInterestReceived = Number(compoundInterestReceived).toFixed(2)
                                                                            compoundedDebt_commissioned = Number(compoundedDebt + offeredLenderCommissionUSD_adjusted).toFixed(2)

                                                                            compoundedDebt = compoundedDebt.toFixed(2);

                                                                            let p = 0;

                                                                            contractColor = null

                                                                            if(currentUser.toLowerCase() == manager.toLowerCase()){
                                                                              if(Number(availableCredit) > 0){
                                                                                balanceColor_1 = 'rgba(0, 158, 129, 1)'
                                                                                balanceFontWeight_1 = '600'
                                                                              } else {
                                                                                balanceColor_1 = 'rgba(0, 0, 0, 1)'
                                                                                balanceFontWeight_1 = '400'
                                                                              }
                                                                              if(Number(compoundedDebt) > 0){
                                                                                balanceColor_2 = 'rgba(204, 12, 12, .70)'
                                                                                balanceFontWeight_2 = '600'
                                                                              } else {
                                                                                balanceColor_2 = 'rgba(0, 0, 0, 1)'
                                                                                balanceFontWeight_2 = '400'
                                                                              }
                                                                            } else {
                                                                              if(Number(receivedPayments) > 0){
                                                                                balanceColor_1 = 'rgba(0, 158, 129, 1)'
                                                                                balanceFontWeight_1 = '600'
                                                                              } else {
                                                                                balanceColor_1 = 'rgba(0, 0, 0, 1)'
                                                                                balanceFontWeight_1 = '400'
                                                                              }
                                                                              if(Number(compoundInterestReceived) > 0){
                                                                                balanceColor_2 = 'rgba(0, 158, 129, 1)'
                                                                                balanceFontWeight_2 = '600'
                                                                              } else {
                                                                                balanceColor_2 = 'rgba(0, 0, 0, 1)'
                                                                                balanceFontWeight_2 = '400'
                                                                              }
                                                                            }
                                                                            

                                                                              if(addedContracts_creditLine.includes(thatContractAddress) == false){
                                                                                if(currentUser.toLowerCase() == manager.toLowerCase()){
                                                                                  if(compoundedDebt > 0){
                                                                                    notif = 'ios-alert'
                                                                                    notifColor = 'rgba(20, 4, 45, 1)'
                                                                                    compoundedDebtColor = 'rgba(204, 12, 12, .75)'
                                                                                  } else {
                                                                                    notif = null
                                                                                    notifColor = 'rgba(20, 4, 45, .0)'
                                                                                    compoundedDebtColor = 'rgba(0, 0, 0, 1)'
                                                                                  } 
  
                                                                                  openBorrowingContractsDetails_creditLine.push(
                                                                                    { 
                                                                                      'fontSize': 11,
                                                                                      fontWeight: '600',
                                                                                      'disabled': false,
                                                                                      'notif': notif,
                                                                                      'notifColor': notifColor,
                                                                                      'balance': String(availableCredit).concat(' USD'),
                                                                                      'minimumContribution': minimumContribution.concat(' USD'),
                                                                                      'blenderScore': blenderScore,
                                                                                      'contractAddress': thatContractAddress,
                                                                                      contractLookupID: lookupKey,
                                                                                      compoundedDebt: String(compoundedDebt).concat(' USD'),
                                                                                      'index': openBorrowingContractsDetails_creditLine.length,
                                                                                      compoundedDebtColor,
                                                                                      balanceColor_1,
                                                                                      balanceColor_2,
                                                                                      balanceFontWeight_1,
                                                                                      balanceFontWeight_2,
                                                                                      blenderScoreColor: isCorporateBondBool ? 'rgba(0, 0, 0, 1)' :'rgba(0, 0, 0, 1)',
                                                                                      contractColor,
                                                                                      paymentStatus, 
                                                                                      paymentStatusColor,
                                                                                      isCorporateBondBool,
                                                                                      backgroundColor,
                                                                                      borderColor,
                                                                                      profilePicture_base64,
                                                                                      profilePicture_uri,
                                                                                      'manager': managerDisplay,
                                                                                      bioString,
                                                                                      fullName,
                                                                                      displayName,
                                                                                      isSubscribedCurrentBool,
                                                                                    },
                                                                                  )

                                                                                } else if((stakedContractsList ?? []).map(address => String(address).toLowerCase()).includes(String(thatContractAddress).toLowerCase())) {

                                                                                  openStakingContractsDetails_creditLine.push(
                                                                                    {
                                                                                      'fontSize': 11,
                                                                                      'disabled': false,
                                                                                      'notif': notif,
                                                                                      'notifColor': notifColor,
                                                                                      'balance': String(Number(stakerCommissionReceivedValueUSD).toFixed(2)).concat(' USD'),
                                                                                      'manager': managerDisplay,
                                                                                      'blenderScore': String(Number(stakerCollateralValueUSD).toFixed(2)).concat(' USD'),
                                                                                      stakedTotalUSD: String(Number(stakerCollateralValueUSD).toFixed(2)).concat(' USD'),
                                                                                      commissionSharePercent: String(Number(stakerCommissionPercentEntitle).toFixed(2)).concat('%'),
                                                                                      'contractAddress': thatContractAddress,
                                                                                      contractLookupID: lookupKey,
                                                                                      compoundedDebt: String(Number(stakerCommissionPercentEntitle).toFixed(2)).concat('%'),
                                                                                      'index': openStakingContractsDetails_creditLine.length,
                                                                                      balanceColor_1,
                                                                                      balanceColor_2,
                                                                                      balanceFontWeight_1,
                                                                                      balanceFontWeight_2,
                                                                                      balanceColor,
                                                                                      blenderScoreColor: isCorporateBondBool ? 'rgba(0, 0, 0, 1)' :'rgba(0, 0, 0, 1)',
                                                                                      contractColor,
                                                                                      paymentStatus,
                                                                                      paymentStatusColor,
                                                                                      isCorporateBondBool,
                                                                                      backgroundColor,
                                                                                      borderColor,
                                                                                      profilePicture_base64,
                                                                                      profilePicture_uri,
                                                                                      bioString,
                                                                                      fullName,
                                                                                      displayName,
                                                                                      isSubscribedCurrentBool,
                                                                                    },
                                                                                  )

                                                                                } else if (
                                                                                  // Only list genuine on-chain lender positions.
                                                                                  // Previously every non-manager/non-staker contract appeared as a lender,
                                                                                  // even when all lending values were zero.
                                                                                  Number(currentUserLoanTotal) > 0 ||
                                                                                  Number(userLiquidValue) > 0 ||
                                                                                  Number(userFinalizedRequestLoanSum) > 0 ||
                                                                                  Number(reclaimableValue) > 0 ||
                                                                                  Number(receivedPayments) > 0
                                                                                ) {
                                                                                  
                                                                                  openLendingContractsDetails_creditLine.push(
                                                                                    { 
                                                                                      'fontSize': 11, 
                                                                                      'disabled': false,
                                                                                      'notif': notif,
                                                                                      'notifColor': notifColor,
                                                                                      'balance': String(receivedPayments).concat(' USD'),  
                                                                                      'manager': managerDisplay,
                                                                                      'blenderScore': String(currentUserLoanTotal).concat(' USD'),
                                                                                      'contractAddress': thatContractAddress,
                                                                                      contractLookupID: lookupKey,
                                                                                      compoundedDebt: safeReclaimableValue + ' USD',
                                                                                      'index': openLendingContractsDetails_creditLine.length,
                                                                                      balanceColor_1,
                                                                                      balanceColor_2,
                                                                                      balanceFontWeight_1,
                                                                                      balanceFontWeight_2,                                                      
                                                                                      balanceColor,
                                                                                      blenderScoreColor: isCorporateBondBool ? 'rgba(0, 0, 0, 1)' :'rgba(0, 0, 0, 1)',
                                                                                      contractColor,
                                                                                      paymentStatus, 
                                                                                      paymentStatusColor,
                                                                                      isCorporateBondBool,
                                                                                      backgroundColor,
                                                                                      borderColor,
                                                                                      profilePicture_base64,
                                                                                      profilePicture_uri,
                                                                                      bioString,
                                                                                      fullName,
                                                                                      displayName,
                                                                                      isSubscribedCurrentBool,
                                                                                    },
                                                                                  )
                                                                                }
                                                                                addedContracts_creditLine.push(thatContractAddress)
                                                                              } else {
                                                                                p++
                                                                              }

                                                                          
                                                                            that.setState({
                                                                              addedContracts_creditLine,
                                                                              openLendingContractsDetails_creditLine,
                                                                              openStakingContractsDetails_creditLine,
                                                                              openBorrowingContractsDetails_creditLine,
                                                                            })
                                                                            

                                                                                        let iconComp;
                                                                                        iconComp = that.state.primaryDisplayCurrency 
              

                                                                                        that.setState({
                                                                                          trigger: 'on',
                                                                                          showOverlay: false,
                                                                                          iconComp,
                                                                                          noAccountsWarning_creditLine,
                                                                                          noAccountsWarning_loanAgreement
                                                                                                      })
                                                                                    
                                                                        
                                                                            }
                                                                    }).catch((err) => {

                                                                    })
                                                                  
                                                                  } catch(err){

                                                                  }
                                                              }).catch((err) => {

                                                              })
                                                              
                                                          })
                                                            
                                                      }

                                                    })

                                                  })
                                        })
                                    })
                                })
                                    
                            }
                            
                            function preBuildContractList(){
                              campaign.methods.getSummary4().call()
                                .then((res) => {

                                  let stakerList = res[0]
                                  // if(stakerList.length > 0){
                                    campaign.methods.totalCollateralAssistanceOwed_staker().call()
                                      .then((totalCollateralAssistanceOwed_staker) => { 
                                        campaign.methods.stakerCollateralValue(publicKey).call()
                                          .then((stakerCollateralValue) => { 
                                            campaign.methods.stakerCommissionReceivedValue(publicKey).call()
                                              .then((stakerCommissionReceivedValue) => { 
                                                campaign.methods.integerCommissionPCT().call()
                                                  .then((integerCommissionPCT) => { 
                                                    campaign.methods.integerStakerDerivedCommissionPCT().call()
                                                      .then((integerStakerDerivedCommissionPCT) => { 


                                                        buildContractLists(
                                                          totalCollateralAssistanceOwed_staker, 
                                                          stakerCollateralValue,
                                                          stakerCommissionReceivedValue,
                                                          integerCommissionPCT,
                                                          integerStakerDerivedCommissionPCT,
                                                          // stakerList
                                                        )

                                                      })
                                                  })
                                              })
                                          })
                                      })

                                }).catch((err) => {
                                  buildContractLists(
                                    0, 
                                    0,
                                    0,
                                    5,
                                    0,
                                    // []
                                  )
                                })
                              
                            }
                          })
                        })
                    } else {
                          
                    }
                    })

                 
                  }
                  
                } else {

                    let iconComp;
                    iconComp = that.state.primaryDisplayCurrency 

                  
                    that.setState({
                      trigger: 'on',
                      showOverlay: false,
                      iconComp,
                      noAccountsWarning_creditLine,
                      noAccountsWarning_loanAgreement
                                  })

                    
                    if(that.state.compoundedDebtSum == '-'){
                      that.setState({
                        compoundedDebtSum: '0.00'
                      })
                    }
                    if(that.state.currentLentSum == '-'){
                      that.setState({
                        currentLentSum: '0.00'
                      })
                    }
                }

              }
              
            })
        })
   
    
  }

  componentDidMount(){


    if(isMobile){
      // window.open("https://lenderblockcorp.com/blenderplatform","_self")
    }
  
    trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
      currentUser = res.username


      let allUserUsernamesDisplayNames = localStorage.getItem('allUserUsernamesDisplayNames')
      if(!allUserUsernamesDisplayNames){
        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'general', 
            primaryKey: 'userArray', 
            requestOperation: 'get',
          }
        }).then((_userArray) => {
          let userArray = _userArray.Item.userArray;
          let allUserUsernamesDisplayNames = []
          function loopAllUsers(u){
            if(u<=userArray.length-1){
              let thisUser = userArray[u];

              allUserUsernamesDisplayNames.push(
                {
                  id: allUserUsernamesDisplayNames.length,
                  name: thisUser
                }
              )
              loopAllUsers(u+1)
            } else {
              that.setState({
                allUserUsernamesDisplayNames
              }, () => {
                
                localStorage.setItem('allUserUsernamesDisplayNames', JSON.stringify(allUserUsernamesDisplayNames))
              })
            }
          }
          loopAllUsers(0)
        })
      } else {
        that.setState({
          allUserUsernamesDisplayNames: JSON.parse(allUserUsernamesDisplayNames)
        })
      }


      that.setState({
        currentUser,
        errorTags: null,
        pendingTransactionLoaderOverlay: false,
        transferCommissionPercentDecimal: 0.05,
      })

      that.setState({
        selectedLanguage: localStorage.getItem('primaryLanguage'),
        mode_light_dark: localStorage.getItem('mode_light_dark'),
      })



          openBorrowingContractsDetails_creditLine = [];
          openLendingContractsDetails_creditLine = [];
          openStakingContractsDetails_creditLine = [];

          that.initialMountComponents()
          that.checkLenderblockSubscriberStatus();

          that.setState({
            exitCountDownNumber: 3,
            flashButtonBorderColor: 'rgba(0, 158, 129, 1)',
            flashButtonBackgroundColor: 'rgba(41, 43, 43, 0.04)',
            flashButtonTextColor: 'rgba(0, 158, 129, 1)',
            verifyIDOverlay: false,
            fundWalletPromptOverlay: false,
            forceVerifyIDOverlay: false,
            verificationPeriodOverlay: false,
            socialOverlay: false,
            socialOverlaySelf: false,
            webViewOverlay: false,
            likedMediaItemMap: {},
            pendingTransactionLoaderOverlay: false,
            openBorrowingContractsDetails_creditLine: [],
            openLendingContractsDetails_creditLine: [],
            openStakingContractsDetails_creditLine: []
                        })
      
      clearInterval(buttonColorFlashIntervalDefault);
    })
  }

  checkLenderblockSubscriberStatus(){
          
    trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
      currentUser = res.username


      that.setState({
        currentUser
      })

      authenticatedPut('api1169ba1e', '', { 
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: { 
          category: 'db',
          tableName: 'users', 
          primaryKey: String(currentUser), 
          requestOperation: 'get',
        }
      }).then((userData) => {
      let primaryDisplayCurrency = userData.Item.preferences.primaryDisplayCurrency
      let secondaryDisplayCurrency = userData.Item.preferences.secondaryDisplayCurrency
      let publicKey = userData.Item.publicKey
      let emailAddress = userData.Item.emailAddress
      let firstName = userData.Item.firstName
      let firstNameFormatted = firstName.substr(0,1).concat(firstName.substr(1,firstName.length-1))


      
      

      

      that.setState({})
      

        
        let headers = new Headers();

        Promise.resolve().then(() => {
if (userData.Item.isSubscribedCurrentBool === true) {
                    
                    isSubscribedCurrentBool = true
                    that.setState({
                        isSubscribedCurrentBool,
                        transferCommissionPercentDecimal: 0
                    })
                    
                  } else {
                    
                    isSubscribedCurrentBool = false
                    that.setState({
                        isSubscribedCurrentBool,
                        transferCommissionPercentDecimal: 0
                    })
                    
                  }
});

      })
    })


  }

  

  chargeUserLinked(){
    // Legacy bank/card payment path replaced by the shared CryptoMoneyPanel.
    return;
  }


  

  withdrawEther(){
    // Legacy bank/card payment path replaced by the shared CryptoMoneyPanel.
    return;
  }

  

  sendTransferFinal(){



    that.setState({
      pendingTransactionLoaderOverlay: true,
    })

    let weiTransferValue = parseInt(Number(that.state.moneyTransactionLiveValue)*1000000000000000000, 10)
    let transferValueUSD = Number(that.state.moneyTransactionLiveValue);

    let destinationUsername = String(that.state.destinationUsername).split(" ").join("")
    let destinationAddress;
    let recipientUser;
    let randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    let randomString2 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    randomString1 =  randomString1.substring(0,18)
    randomString2 =  randomString2.substring(0,18)

    that.setState({
        showPageLoader: true,
        showPasswordOverlay: false,
        password: String(that.state.passwordText).replace(/\s/g, '')
    })

    if(that.state.destinationUsername != null){

            recipientUser = destinationUsername.toLowerCase()
            that.setState({
              recipientUser
            })

            authenticatedPut('api1169ba1e', '', { 
                headers: { Authorization: `Bearer ${cognitoID}` },
                body: { 
                category: 'db',
                tableName: 'users', 
                primaryKey: recipientUser.toLowerCase(), 
                requestOperation: 'get',
                }
            }).then((recipient) => {
              if(recipient.hasOwnProperty('Item')){
                  destinationAddress = recipient.Item.publicKey
              

                  let recipientFirstName = recipient.Item.firstName
                  let recipientEmailAddress = recipient.Item.emailAddress

                  authenticatedPut('api1169ba1e', '', { 
                      headers: { Authorization: `Bearer ${cognitoID}` },
                      body: { 
                        category: 'db',
                        tableName: 'users', 
                        primaryKey: currentUser, 
                        requestOperation: 'get',
                      }
                  }).then(async (response) => {

                      let publicKey = response.Item.publicKey
                      let emailAddress = response.Item.emailAddress
                      let firstName = response.Item.firstName
                      let privateKey = response.Item.privateKey


                      let bytes = CryptoJS.AES.decrypt(String(privateKey), that.state.passwordText);


                      var plaintextPK

                      // Recipient amount + Blender commission equals the entered total.
                      // The commission is not charged twice; reserve gas for both transactions.
                      const transferNetworkFeeWei = ethers.BigNumber.from('200000').mul('1200000000').mul(2);
                      let confirmedBalanceWei;
                      try {
                        const liveBalance = await highRateWeb3.eth.getBalance(publicKey);
                        confirmedBalanceWei = ethers.BigNumber.from(String(liveBalance));
                      } catch (balanceError) {
                        that.setState({
                          errorTags: <p style={{ textAlign: 'left' }}>
                            {that.state.selectedLanguage == 'spanish'
                              ? 'No se pudo verificar el saldo de tu Cartera Blender. Inténtalo de nuevo.'
                              : 'Could Not Verify Your Blender Wallet Balance. Please Try Again.'}
                          </p>,
                          showInsufficientFundsOverlay: false,
                          showConfirmationOverlay: false,
                          pendingTransactionLoaderOverlay: false,
                          showPageLoader: false,
                          disableWhileTxn: false,
                        });
                        return;
                      }
                      const transferSpendableWei = confirmedBalanceWei.gt(transferNetworkFeeWei)
                        ? confirmedBalanceWei.sub(transferNetworkFeeWei) : ethers.constants.Zero;
                      const transferAmountWei = ethers.utils.parseEther(String(that.state.moneyTransactionLiveValue).trim());

                      if(transferAmountWei.gt(0) && transferAmountWei.lte(transferSpendableWei)){
                        try{
                          plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
                          finishTxn()
                        } catch(err){
                          
                          
                          that.setState({
                            errorTags: 
                              <p style={{ textAlign: 'left', }}>
                                {that.state.selectedLanguage == 'spanish' ? 
                                  'Contraseña no Válida'
                                    :
                                  'Incorrect Password'
                                }
                              </p>,
                              showInsufficientFundsOverlay: false,
                              showConfirmationOverlay: false,
                              pendingTransactionLoaderOverlay: false,
                              showPageLoader: false,
                              password: null,
                              actionValue: null,
                              disableWhileTxn: false,
                          })
                        }
                      } else {
                        
                        that.setState({
                          errorTags: 
                            <p style={{ textAlign: 'left', }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                `El valor máximo de transferir desde tu cartera Blender es ${(Math.floor(Number(ethers.utils.formatEther(transferSpendableWei)) * 100) / 100).toFixed(2)} USD`
                                  :
                                `The maximum transfer value from your Blender Wallet is ${(Math.floor(Number(ethers.utils.formatEther(transferSpendableWei)) * 100) / 100).toFixed(2)} USD`
                              }
                            </p>,
                            showInsufficientFundsOverlay: false,
                            showConfirmationOverlay: false,
                            pendingTransactionLoaderOverlay: false,
                            showPageLoader: false,
                            password: null,
                            actionValue: null,
                            disableWhileTxn: false,
                        })
                      }

                      function finishTxn(){

                          plaintextPK = plaintextPK.substring(64, plaintextPK.length-64) 


                          let mnemonicWallet = ethers.Wallet.fromMnemonic(plaintextPK);
                          var plaintextMnemonic = mnemonicWallet.privateKey

                          highRateWeb3.eth.getTransactionCount(publicKey).then((_nonce) => {
                          
                            const nonce = _nonce;

                            const tx_sendTransfer = { 
                              chainId: 100,
                              gas: '200000',
                              gasPrice: String(1200000000),
                              from: publicKey, 
                              to: destinationAddress, 
                              value: (Number(weiTransferValue)*(1-that.state.transferCommissionPercentDecimal)).toLocaleString('fullwide', {useGrouping: false}),
                              data: "",
                              nonce: nonce
                            }
  
                            const tx_sendTransfer_commission = { 
                              chainId: 100,
                              gas: '200000',
                              gasPrice: String(1200000000),
                              from: publicKey, 
                              to: blenderCommissionPublicKey, 
                              value: (Number(weiTransferValue)*that.state.transferCommissionPercentDecimal).toLocaleString('fullwide', {useGrouping: false}),
                              data: "",
                              nonce: nonce+1
                            }

                            var tx_sendTransfer_receipt;

                            highRateWeb3.eth.accounts.signTransaction(tx_sendTransfer_commission, plaintextMnemonic)
                              .then((signedTx_sendTransferCommission) => {

                                highRateWeb3.eth.accounts.signTransaction(tx_sendTransfer, plaintextMnemonic)
                                  .then((signedTx_sendTransfer) => {


                                    highRateWeb3.eth.sendSignedTransaction(signedTx_sendTransfer.rawTransaction).then((_tx_sendTransfer_receipt) => {
                                      tx_sendTransfer_receipt = _tx_sendTransfer_receipt.transactionHash
                                    }).then((res) => {

                                      highRateWeb3.eth.sendSignedTransaction(signedTx_sendTransferCommission.rawTransaction).then((receipt) => {

                                        if(that.state.selectedLanguage == 'spanish'){
                                          if(that.state.isSubscribedCurrentBool){
                                            that.setNativeNotification(`Blender Pro Plus Ahorros - Has guardado ${Number(Number(transferValueUSD)*0.05).toFixed(2)} USD por transferir a ${String(recipientUser).toUpperCase()}!`)
                                          } else {
                                            that.setNativeNotification(`Transferiste ${Number(transferValueUSD).toFixed(2)} USD a ${String(recipientUser).toUpperCase()}!`)
                                          }
                                        } else {
                                          if(that.state.isSubscribedCurrentBool){
                                            that.setNativeNotification(`Blender Pro Plus Savings - You saved ${Number(Number(transferValueUSD)*0.05).toFixed(2)} USD transferring to ${String(recipientUser).toUpperCase()}!`)
                                          } else {
                                            that.setNativeNotification(`You transferred ${Number(transferValueUSD).toFixed(2)} USD to ${String(recipientUser).toUpperCase()}!`)
                                          }
                                        }


                                        authenticatedPut('api1169ba1e', '', { 
                                          headers: { Authorization: `Bearer ${cognitoID}` },
                                          body: { 
                                              category: 'db',
                                              tableName: 'pendingTransactions', 
                                              primaryKey: tx_sendTransfer_receipt, 
                                              requestOperation: 'update',
                                              updateExpression: 
                                              `SET 
                                                  transactionType = :txnType,
                                                  creationDate = :creationDate, 
                                                  creationDateSecs = :creationDateSecs, 
                                                  #st = :status, 
                                                  currentUser = :currentUser,
                                                  publicKey = :publicKey,
                                                  emailType = :emailType,
                                                  firstName = :firstName,
                                                  emailAddress = :emailAddress,
                                                  adjustedWeiValueNum = :adjustedWeiValueNum,
                                                  recipientUser = :recipientUser,
                                                  recipient = :recipient,
                                                  recipientEmailAddress = :recipientEmailAddress,
                                                  recipientFirstName = :recipientFirstName,
                                                  randomString1 = :randomString1,
                                                  randomString2 = :randomString2,
                                                  application = :application,
                                                  currency = :currency,
                                                  conversionRateGlobal = :conversionRateGlobal
                                              `,
                                              expressionAttributeNames: {"#st":"status"},
                                              expressionAttributeValues: { 
                                                  ':txnType': 'transfer',
                                                  ':creationDate': new Date(),
                                                  ':creationDateSecs': Date.now(), 
                                                  ':currentUser': currentUser,
                                                  ':status': 'active',
                                                  ':publicKey': publicKey,
                                                  ':emailAddress': emailAddress,
                                                  ':emailType': 'contribution',
                                                  ':firstName': firstName,
                                                  ':adjustedWeiValueNum': Number(weiTransferValue) * (-1),
                                                  ':recipientUser': recipientUser,
                                                  ':recipient': destinationAddress,
                                                  ':randomString1': randomString1,
                                                  ':randomString2': randomString2,
                                                  ':recipientEmailAddress': recipientEmailAddress,
                                                  ':recipientFirstName': recipientFirstName,
                                                  ':application': 'TBP',
                                                  ':currency': 'USD',
                                                  ':conversionRateGlobal': 1
                                              }
                                          }
                                          }).then((res) => {

                                              authenticatedPut('api1169ba1e', '', { 
                                                headers: { Authorization: `Bearer ${cognitoID}` },
                                                body: { 
                                                    category: 'db',
                                                    tableName: 'general', 
                                                    primaryKey: 'txnHash', 
                                                    requestOperation: 'update',
                                                    updateExpression: `SET txnHash = list_append(txnHash, :txnHash)`, 
                                                    expressionAttributeValues: { 
                                                      ':txnHash': [tx_sendTransfer_receipt]
                                                    }
                                                }
                                              }).then((res) => {

                                                if(that.state.isSubscribedCurrentBool){
                                                  that.setState({
                                                    successSubscriberSavingsOverlay: true,
                                                    pendingTransactionLoaderOverlay: false,
                                                  })
                                                } else {
                                                  that.setState({
                                                    pendingTransactionLoaderOverlay: false,
                                                    successfulTransferOverlay: true,
                                                    pendingTransactionLoaderOverlay: false,
                                                  })
                                                }

                                                that.setState({
                                                    showInsufficientFundsOverlay: false,
                                                    showConfirmationOverlay: false,
                                                    showPasswordOverlay: false,
                                                    showPageLoader: false,
                                                    password: null,
                                                    actionValue: null,
                                                    disableWhileTxn: false,
                                                })
                                                setTimeout(() => {
                                                  that.setState({
                                                    successfulTransferOverlay: false,
                                                    successSubscriberSavingsOverlay: false,
                                                  })
                                                }, 3000)
                                          })
                                      })




                                      }).catch((err) => {
                                      })
                                    }).catch((err) => {
                                    });

                                }).catch((err) => {
                                })
                              }).catch((err) => {
                              });
                          })

                          plaintextPK = null
                          privateKey = null

                      }
                  })
              } else{
                
                that.setState({
                  errorTags: 
                    <p
                      style={{
                        textAlign: 'left',
                      }}
                    >
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Recipiente no Válida'
                          :
                        'Invalid Recipient'
                      }
                    </p>,
                  showPasswordOverlay: false,
                  pendingTransactionLoaderOverlay: false,
                })
              }
          })


    }
  }

  initialMountComponents(){
    // that.listRefVert.scrollToOffset({ y: 0, animated: true })


    trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
      currentUser = res.username
      cognitoID = res.signInUserSession.idToken.jwtToken

      currentUserCap = currentUser.toUpperCase()
      if(currentUserCap.length > 10){
        currentUserCap =  currentUserCap.substr(0, 9).concat(' ...')
      }
      that.setState({ currentUser })
      
      that.formContents()


      let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${currentUser.toLowerCase()}`;

      that.setState({
        currentUserProfilePicture: profilePicture_uri,
        moneyTransferOverlay: false,
      })

      Storage.get(
        `${currentUser.toLowerCase()}/profilePicture.jpg`,
        {
            bucket: "platform-user-media-uploads",
            level: "public"
        }
      ).then((res) => {
        trackPageRequest(fetch(
          res
        )).then((image) => {
          if(image.status == 200){
            profilePicture_uri = res;
          }
          that.setState({
            currentUserProfilePicture: profilePicture_uri
          })
        })
      })
      
      authenticatedPut('api1169ba1e', '', { 
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: { 
          category: 'db',
          tableName: 'users', 
          primaryKey: String(currentUser), 
          requestOperation: 'get',
        }
      }).then((userData) => {
        let firstName = userData.Item.firstName ?? ''
        let lastName = userData.Item.lastName ?? ''

        let fullName = firstName.substring(0,1).toUpperCase()+firstName.substring(1,firstName.length) + ' ' + lastName.substring(0,1).toUpperCase()+lastName.substring(1,lastName.length)
        

        primaryDisplayCurrency = userData.Item.preferences.primaryDisplayCurrency
        secondaryDisplayCurrency = userData.Item.preferences.secondaryDisplayCurrency
        publicKey = userData.Item.publicKey

          if(web3.utils.isAddress(publicKey)){

            trackPageRequest(web3.eth.getBalance(publicKey)).then((balance) => {

              walletBalanceWei = Math.max(
                0,
                Number(balance) - (2000000 * 4000000000)
              )

              that.setState({
                walletBalanceUSD: walletBalanceWei / 1000000000000000000,
                walletBalanceWei: walletBalanceWei,
                maxWalletWithdrawalWei: walletBalanceWei,
                publicKey: publicKey,
              })

            }).catch((err) => {

            })

          } else {


          }

        stakedContractsList = userData.Item.stakedContracts;

        
        
        emailAddress = userData.Item.emailAddress

        that.setState({
          emailAddress
                      })

        
      
        let profilePicture_base64 = null;
        let profile_imageURI = null;
        let profile_bioString = null
        let profile_weblink1 = null;
        let profile_weblink2 = null;
        let profile_weblink3 = null;

        profile_imageURI = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${currentUser.toLowerCase()}`;

        
        Storage.get(
          `${currentUser.toLowerCase()}/profilePicture.jpg`,
          {
              bucket: "platform-user-media-uploads",
              level: "public"
          }
        ).then((res) => {
          trackPageRequest(fetch(
            res
          )).then((image) => {

            if(image.status == 200){
              profile_imageURI = res;
            }

            authenticatedPut('api1169ba1e', '', { 
              headers: { Authorization: `Bearer ${cognitoID}` },
              body: { 
                  category: 'db',
                  tableName: 'socialUserData', 
                  primaryKey: String(currentUser), 
                  requestOperation: 'get',
              }
            }).then((socialUserData) => {
              if(socialUserData.hasOwnProperty('Item')){

                if(socialUserData.Item.hasOwnProperty('profile_bioString')){
                  profile_bioString = String(socialUserData.Item.profile_bioString)
                } else {
                  profile_bioString = 'No Bio :('
                }
                if(socialUserData.Item.hasOwnProperty('weblink1')){
                  profile_weblink1 = String(socialUserData.Item.weblink1)
                } else {
                  profile_weblink1 = null
                }
                if(socialUserData.Item.hasOwnProperty('weblink2')){
                  profile_weblink2 = String(socialUserData.Item.weblink2)
                } else {
                  profile_weblink2 = null
                }
                if(socialUserData.Item.hasOwnProperty('weblink3')){
                  profile_weblink3 = String(socialUserData.Item.weblink3)
                } else {
                  profile_weblink3 = null
                }
              } else {
                profile_imageURI = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${currentUser}`;
                profilePicture_base64 = profile_imageURI
                profile_bioString = 'No Bio :('
                profile_weblink1 = null
                profile_weblink2 = null
                profile_weblink3 = null
              }
      
              that.setState({
                currentUserProfile_imageURI: (
                  profilePicture_base64
                  ?
                  profilePicture_base64
                  :
                  profile_imageURI
                ),
                socialData_bioString: profile_bioString,
                profile_weblink1,
                profile_weblink2,
                profile_weblink3,
                currentUserFullName: fullName
              })
            })
          }).catch((err) => {

          })
        })

        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'platformConfigurations', 
            primaryKey: 'corporateBackedUsernamesArray', 
            requestOperation: 'get',
          }
        }).then((_corporateBackedUsernamesArray) => {
          corporateBackedUsernamesArray = _corporateBackedUsernamesArray.Item.corporateBackedUsernamesArray
        })

      
        
        
        that.setState({
           primaryDisplayCurrency,
           secondaryDisplayCurrency,
        })

          
      })
    });














        





  
  }

    render(){
        applicantUsername = that.props.username
     
        const { touched } = that.state;
        const className = touched ? 'button1_touched' : 'button1';

        if(navigationHandler(that.state.navigationDestinationObject)){
            return navigationHandler(that.state.navigationDestinationObject)
        }
      const renderProps = { API, AWS, Amplify, Auth, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, Component, Container, CryptoJS, Form, FormField, Fragment, Header, Home, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, PIXELAJUST, Radio, React, ReactSearchAutocomplete, Storage, ThreeDot, USDEtherConversionRate, Web3, addedContracts_creditLine, addedContracts_loanAgreement, allDaysElapsed, allValues, applicantUsername, awsconfig, axios, blenderCommissionPublicKey, blenderPrivateKey, blenderScore, blenderTransfersToPublicKey, buttonColorFlashIntervalDefault, cardEntryFormTimer, cardFundComponent, chartData, chartDayRange, checkValidAuthTokenInterval, checkValidAuthTokenIntervalPeriod_ms, city, className, cognitoID, compoundedDebtSum, corporateBackedUsernamesArray, country, countryCodeSwappedJSON, countryCodeSwappedJSONList, countryCodes, countryNames, currentLentSum, currentUser, currentUserCap, debounce, emailAddress, ethers, exitFundWalletTimer, exitTutorialTimer_1, exitTutorialTimer_2, exitTutorialTimer_3, firstName, flashCounter, forexJSON, fullAddress, fullName, fundWalletPromptDidBool, highRateWeb3, isMobile, isSubscribedCurrentBool, joinDateSecs, lastName, lastNonce, lenders, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, mode_light_dark, monthLengtheningEnum, navigationHandler, noAccountsWarning_creditLine, noAccountsWarning_loanAgreement, notificationCount, notifs, openBorrowingContractsDetails_creditLine, openBorrowingContractsDetails_loanAgreement, openContracts, openLendingContractsDetails_creditLine, openLendingContractsDetails_loanAgreement, openStakingContractsDetails_creditLine, openStakingContractsDetails_loanAgreement, optionCountryCodeSwappedJSON, pageOrigin, postalCode, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, privateKey, proposeGasPrice, publicKey, rand1, rand2, rand3, rand4, resultMessageTimer, routeProps, secondaryDisplayCurrency, secondaryDisplayPrice, squareCustomerID, stakedContractsList, state, street, that, tokenID, tokenLifeTimeLimit, totalBorrContracts, touched, useLayoutEffect, useParams, useRef, verifyOverlayShownBool, walletBalanceWei, web3 };

      if (isMobile) {
        return <HomeMobileRender {...renderProps} />;
      }

      return <HomeDesktopRender {...renderProps} />;
    }

}


function Home(props){
  const {username} = useParams();

  return (<HomeComponent username={username}/>)
}

export default Home;

